export const sent_emails = {
  documentTitle: "Sent emails",
  title: "Sent emails",
  filter_label: "Filter by recipient",
  no_emails: "No emails have been sent yet.",
  email_details: {
    to: "To",
    cc: "CC",
    bcc: "BCC",
    from: "From",
    replyTo: "Reply To",
    subject: "Subject",
    text: "Text",
    html: "HTML",
  },
};
